<template>
  <v-container v-if="!containerInitLoading && contract" fluid class="pa-0" style="height: inherit">
    <!--
    <v-row no-gutters>
      <v-col>
        <h2>Invoicing graph</h2>
        last invoice date: {{ i18nFormatDate(contract.LastInvoiceDate) }} <br>
        total cost: {{ contract.TotalCost }} <br>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row no-gutters>
      <v-col>
        <v-card class="ma-3 pa-3" flat style="width: 350px;">
          <ContractStepper :current-state="state" @transition="handleTransition">
          </ContractStepper>
        </v-card>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    -->
    <v-row no-gutters align="stretch" style="height: inherit">
      <v-col class="pa-3">
        <v-row>
          <v-col cols="0">
            <h2>{{ $t('servicesystem.common_objects.customer.customer') }}</h2>
          </v-col>
          <v-col cols="auto" class="pr-0">
            <v-btn small color="primary" outlined
              :to="{ name: 'ViewCustomer', params: { customerId: contract.CustomerId } }">
              {{ $t('servicesystem.common_objects.commonterms.open') }}
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn
              small
              color="secondary"
              outlined
              @click="changeCustomerDialogTrigger++"
            >
              {{ $t('servicesystem.common_objects.commonterms.change') }}
            </v-btn>
          </v-col>
        </v-row>
        <QTextField v-model="contract.Customer.Id" :label="$t('servicesystem.common_objects.customer.customer_number')"
          disabled class="mb-2">
        </QTextField>
        <QTextField v-model="contract.Customer.Name" :label="$t('servicesystem.common_objects.commonterms.name')"
          disabled class="mb-2">
        </QTextField>
        <QTextField v-model="contract.Customer.OrganisationNumber"
          :label="$t('servicesystem.common_objects.customer.organization_number')" disabled class="mb-2">
        </QTextField>
        <QTextField :label="$t('servicesystem.common_objects.customer.credit_limit')"
          :value="contract.Customer.CreditLimit ? contract.Customer.CreditLimit : $t('servicesystem.common_objects.commonterms.none')"
          :suffix="contract.Customer.CreditLimitExceeded ? (' (' + contract.Customer.CreditLimitExceeded + ')') : null"
          :valuecolor="contract.Customer.CreditLimit ? (contract.Customer.CreditLimitExceeded ? 'error' : 'primary') : 'disabled'"
          disabled class="mb-2">
        </QTextField>
        <QTextField :label="$t('servicesystem.common_objects.customer.free_from_vat')"
          :value="contract.Customer.FreeFromVat ? $t('servicesystem.common_objects.commonterms.yes') : $t('servicesystem.common_objects.commonterms.no')"
          disabled class="mb-2">
        </QTextField>

        <v-row class="mt-2" align="center">
          <v-col cols="auto">
            <h4>{{ $t('servicesystem.common_objects.contact.customer_contact') }}</h4>
          </v-col>
          <v-col cols="0" class="pl-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <ContactTemplate v-if="!contactListOpen" :Contact="contract.CustomerPerson" :hideTitle="contactListOpen"
          :hideMobile="contactListOpen" :loading="loading || swappingContact">
          <template v-slot:action-buttons>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="AllowSwapContact" v-bind="attrs" v-on="on" icon @click="contactListOpen = true">
                  <v-icon size="40">mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("servicesystem.text.swap") }}</span>
            </v-tooltip>
          </template>
        </ContactTemplate>
        <ContactList v-if="contactListOpen" :CustomerId="contract.Customer.Id" :Selected="contract.CustomerPerson"
          :disableNew="true" @Select="setContact" @Close="contactListOpen = false" />
      </v-col>

      <v-divider vertical style="z-index: 1;"></v-divider>

      <v-col>
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="contract"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <ContractEditContent :item="item" :editMode="editMode" :handleFocus="handleFocus">
            </ContractEditContent>
          </template>
        </EntityEditCard>
      </v-col>
    </v-row>

    <ChangeContractCustomerDialog
      v-if="contract"
      :externaltrigger="changeCustomerDialogTrigger"
      :contractId="contract.Id"
      :currentCustomerId="contract.CustomerId"
      @Changed="(c) => (contract = c)"
    />
    <!--
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col>
        <h2>Detail summary</h2>
      </v-col>
    </v-row>
     -->
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import ContractEditContent from "@/views/contracts/ContractEditContent.vue";
import ContactTemplate from "@/components/Preview/Customer/ContactTemplate.vue";
import ContactList from "@/components/Preview/Customer/ContactList.vue";
import ChangeContractCustomerDialog from "@/components/Dialogs/ChangeContractCustomerDialog.vue";
//import ContractStepper from "./ContractStepper.vue";

export default {
  name: "ViewContractInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    ContractEditContent,
    ContactTemplate,
    ContactList,
    ChangeContractCustomerDialog,
    //ContractStepper
  },
  mixins: [clientAPI],

  data() {
    return {
      state: 'Draft',
      contactListOpen: false,
      swappingContact: false,
      changeCustomerDialogTrigger: 0,
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.changeContract(dto)
        .then((response) => {
          this.contract = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    handleTransition(payload) {
      // e.g. show confirm dialog then update state
      console.log('Transition requested', payload.from, '→', payload.to);
      this.state = payload.to;
    },

    setContact(newContact) {
      if (!this.contract || !newContact) {
        this.contactListOpen = false;
        return;
      }
      this.swappingContact = true;
      this.swapContractContact(this.contract.Id, String(newContact.Id))
        .then((response) => {
          this.contract = response;
          this.contactListOpen = false;
        })
        .catch((err) => {
          console.error("swapContractContact error", err);
        })
        .finally(() => {
          this.swappingContact = false;
        });
    },
  },

  computed: {
    contract: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

    loading() {
      return this.containerLoading;
    },

    AllowSwapContact() {
      return true // this.checkPermission("Actions", "swapJobCustomerContact");
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>